import { render, staticRenderFns } from "./CarrierData.vue?vue&type=template&id=63ef43ac&scoped=true"
import script from "./CarrierData.vue?vue&type=script&lang=js"
export * from "./CarrierData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ef43ac",
  null
  
)

export default component.exports